import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { FC, useId } from "react";
import { Tooltip } from "react-tooltip";

// Fixed positioning: the modal clips its overflow.
const InfoTip: FC<{ text: string }> = ({ text }) => {
  const id = `cancellation-tip-${useId()}`;
  return (
    <>
      <InformationCircleIcon className="w-4 h-4 shrink-0 text-gray-400 cursor-help" strokeWidth={2}
        role="img" aria-label={text} data-tooltip-id={id} data-tooltip-content={text}
        data-tooltip-variant="dark" />
      <Tooltip id={id} positionStrategy="fixed" className="z-50 max-w-xs !text-xs" />
    </>
  );
};

export default InfoTip;
